import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_OVERVIEW: MijnRoute = {
    path: 'hypotheek',
    navigationEvent: 'toHypotheek',
    regex: /^\/hypotheek$/,
    webcomponent: 'mijn-hypotheken-home-webcomponent'
};
